angular.module('TetherApp').controller('QuickLinkController', [
    '$mdMenu',
    '$mdToast',
    'quickLinkService',
    function (
        $mdMenu,
        $mdToast,
        quickLinkService
    ) {
        let self = this;
        self.errors = {};
        self.quickLink = { name: '' };
        self.user_id = undefined;
        self.client_id = undefined;

        self.storeQuickLink = function (userId, clientId) {
            self.errors = {};
            self.quickLink.url = window.location.href;
            self.quickLink.user_id = self.user_id;
            self.quickLink.client_id = self.client_id;
            quickLinkService.storeQuickLink(self.quickLink)
                .then(onStoreQuickLink, onError);
        };

        let onStoreQuickLink = function (data) {
            $mdMenu.hide();
            self.quickLink.name = '';
            self.quickLink.user_id = undefined;
            self.quickLink.client_id = undefined;
            self.fetchUserQuickLinks();
            $mdToast.show({
                hideDelay   : 2500,
                position    : 'bottom left',
                template : '<md-toast style="max-width: 425px">' +
                    '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> ' +
                    data.success +
                    '</span>' +
                    '</md-toast>'
            });
        };

        self.fetchUserQuickLinks = function () {
            quickLinkService.getUserQuickLinks({
                user_id: self.user_id,
                client_id: self.client_id,
            }).then(onFetchUserQuickLinks, onError);
        };

        let onFetchUserQuickLinks = function (data) {
            self.userQuickLinks = data;
        };

        self.deleteQuickLink = function (quickLinkId, isReload) {
            self.isReload = isReload == undefined ? false : true;
            quickLinkService.deleteQuickLink(
                quickLinkId,
                {
                    user_id: self.user_id,
                    client_id: self.client_id
                }
            ).then(onDeleteQuickLink, onError);
        };

        let onDeleteQuickLink = function (data) {
            if (self.isReload) {
                window.location.reload();
            } else {
                self.fetchUserQuickLinks();
                $mdToast.show({
                    hideDelay   : 2500,
                    position    : 'bottom left',
                    template : '<md-toast style="max-width: 425px">' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> ' +
                        data.success +
                        '</span>' +
                        '</md-toast>'
                });
            }
        };

        let onError = function (error) {
            if (error.hasOwnProperty('data') && error.data.hasOwnProperty('name')) {
                self.errors.name = error.data.name[0];
            } else {
                $mdToast.show({
                    hideDelay   : 2000,
                    position    : 'bottom left',
                    template : '<md-toast style="max-width: 350px">' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> ' +
                        'An error occurred please contact support' +
                        '</span>' +
                        '</md-toast>'
                });
            }
        };
    }
]);
